import Nav from './Nav'


function Pillar3() {
    let selectedPil="pillar ";
    let pillarHeading="";
    let pillar1Text="";
  
      selectedPil += " economic-response";
      pillarHeading = "Economic Response and Recovery";
      pillar1Text="The COVID-19 crisis plunged the world economy into a recession with historical levels of unemployment and deprivation, meaning this is a crisis of jobs and livelihoods as well health. Small and medium-sized enterprises, farm workers, the self-employed, daily wage earners, informal sector workers, women, youth, refugees and migrant workers are hit the hardest. In response, the UN has focused on supporting member states and constituents in developing policies and programmes to protect jobs and incomes of the most vulnerable workers and hard-hit sectors to prevent the collapse of economic activity and associated labour market distress. Ensuring the continued or improved functioning of small producers, informal workers and SMEs across sectors is vital to ensure production of, and access to, food and other essential goods and services.";
      return(
        <>
        <Nav active="p3" />
        <div className={selectedPil}>
                  <PillarStart text={pillar1Text} pilHeading={pillarHeading} />
                  <div className="customcontainer">
                    <TopKeyFigureSection active="p3" />
                    <Pillar3IndicatorSection heading="Companies/Workers Supported" indiNum="1" kfHeading="Companies" lineChart1Heading="Quarterly Progress (MSMEs and Companies)" lineChart2Heading ="Quarterly Progress (Workers)" />
                    <Pillar3IndicatorSection heading="Beneficiaries of Food Supply Protection Regimes" indiNum="2" kfHeading="People Supported" lineChart1Heading="Quarterly Progress" lineChart2Heading ="" />

                  </div>
                  <TableSection />
        </div>
        </>
      );

}

function TableSection()
{
  return(
    <div className="white-background">
      <div className="customcontainer">
          <div className="customrow">
              <div className="col-md-12">
                  <div className="title">
                      <div className="funded"></div>
                      <div className="text pillar">&nbsp;</div>
                  </div>
              </div>
              <table id="table" className="table table-hover"></table>
          </div>
      </div>
  </div>
  )
}

function PillarStart({text,pilHeading}){
    return (
      <div className="customcontainer">
                    <div className="topContent"><p>{text}</p></div>
                    <div className="customrow">
                        <div className="col-md-12">
                            <h1 className="pillar-title">
                                {pilHeading}
                            </h1>
                        </div>
                    </div>
                </div>
    )
  }

function TopKeyFigureSection({active})
{
    return(
        <div className="customrow">
          <div className="col-md-12">
            <div className="pillar3-blocks">
              <TopKeyFigure heading="FOOD SUPPLY PROTECTION REGIMES" div_id="1" keyFigure = "5.7 M"/>
              <TopKeyFigure heading="WORKERS SUPPORTED (FORMAL AND INFORMAL) " div_id="2" keyFigure = "1.9 M"/>
            </div>
          </div>
        </div>
      )
}

function TopKeyFigure({heading, div_id, keyFigure})
{
  let divNAid="top-number"+div_id+"NA";
  let divID="top-number"+div_id;
  return(
    <div className="pillar-block">
      <div className="header">
          <div className="text text-center">
              {heading}
          </div>
      </div>
      <div className="body">
          <div className="counter text-center">
              <span id={divNAid}></span>
              <span id={divID}>{keyFigure}</span>
          </div>
      </div>
  </div>
  )
}


function IndKeyFigure({heading,div_id,indValue})
{
  console.log(div_id);
  return(
    <>
      <div className="counter text-center">
        <span id={div_id} className="kf-number">{indValue}</span>
      </div>
      <div className="title" style={{textAlign: 'center'}}>
          <div className="text">{heading}</div>
      </div>
    </>
  )
}


function Pillar3IndicatorSection({heading,indiNum,kfHeading,lineChart1Heading, lineChart2Heading}){
    let indDivID="Ind3."+indiNum;
    let kfDivID="number"+indiNum;
    let qrtChartID="";
    let rowChartID="";
    let qrtChartContainerID="";
    let qrtNAContainerID="";
    let rowChartContainerID="";
    let rowNAContainerID="";
    if(indiNum ==="1")
    {
          qrtChartID="chart1-3."+indiNum;
          rowChartID="chart2-3."+indiNum;
          qrtChartContainerID="quater"+indiNum;
          rowChartContainerID="indicator"+indiNum;
          qrtNAContainerID="3."+indiNum+"chart1NA";
          rowNAContainerID="3."+indiNum+"chart2NA";
      
          return(
            <div id={indDivID} className="customrow">
              <div className="pillar economic-response">
                  <div className="customcontainer">
                      <div className="customrow">
                          <div className="col-md-12">
                              <h1 className="indicator-title">
                                  {heading}
                              </h1>
                          </div>
                      </div>
                  </div>
              </div>
              <div className="col-md-2">
                <div className="funded">
                  <div className="body">
                    <div className="burger">
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                    </div>
                    <IndKeyFigure heading={kfHeading} div_id={kfDivID} unit="" indValue = "374.6 K"/>
                  </div>
                </div>
              </div>
              <div id={qrtChartID} className="col-md-5">
                <div className="funded">
                    <div className="title">
                        <div className="text">{lineChart1Heading}</div>
                    </div>
                    <div className="content">
                        <div id={qrtChartContainerID}>
                        </div>
                        <div id={qrtNAContainerID} className="title" style={{textAlign: 'center'}}>
                        <canvas style={{height: '130px', width:'130px', backgroundColor: '#fff'}} id="CG3.2a" width="50" height="50" />
                            <div className="kf-number" style={{paddingTop: '70px', display: 'none'}}>N/A</div>
                        </div>
                    </div>
                </div>
              </div>
              <div id={rowChartID} className="col-md-5">
                  <div className="funded">
                      <div className="title">
                          <div className="text">{lineChart2Heading}</div>
                      </div>
                      <div className="content">
                          <div id={rowChartContainerID}>
                          </div>
                          <div id={rowNAContainerID} className="title" style={{textAlign: 'center'}}>
                          <canvas style={{height: '130px', width:'130px', backgroundColor: '#fff'}} id="CG3.2b" width="50" height="50" />
                              <div className="kf-number" style={{paddingTop: '70px', display: 'none'}}>N/A</div>
                          </div>
                      </div>
                  </div>
              </div>
            </div>
          );
        }
    else
    {
      if(indiNum ==="2")
      {
      qrtChartID="chart1-3."+indiNum;
          rowChartID="chart2-3."+indiNum;
          qrtChartContainerID="quater"+indiNum;
          rowChartContainerID="indicator"+indiNum;
          qrtNAContainerID="3."+indiNum+"chart1NA";
          rowNAContainerID="3."+indiNum+"chart2NA";
      
          return(
            <div id={indDivID} className="customrow">
              <div className="pillar economic-response">
                  <div className="customcontainer">
                      <div className="customrow">
                          <div className="col-md-12">
                              <h1 className="indicator-title">
                                  {heading}
                              </h1>
                          </div>
                      </div>
                  </div>
              </div>
              <div className="col-md-2">
                <div className="funded">
                  <div className="body">
                    <div className="burger">
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                    </div>
                    <IndKeyFigure heading={kfHeading} div_id={kfDivID} unit="" indValue = "5.7 M"/>
                  </div>
                </div>
              </div>
              <div id={qrtChartID} className="col-md-5">
                <div className="funded">
                    <div className="title">
                        <div className="text">{lineChart1Heading}</div>
                    </div>
                    <div className="content">
                        <div id={qrtChartContainerID}>
                        </div>
                        <div id={qrtNAContainerID} className="title" style={{textAlign: 'center'}}>
                        <canvas style={{height: '130px', width:'130px', backgroundColor: '#fff'}} id="CG3.4a" width="50" height="50" />
                            <div className="kf-number" style={{paddingTop: '70px', display: 'none'}}>N/A</div>
                        </div>
                    </div>
                </div>
              </div>
              {/* <div id={rowChartID} className="col-md-5">
                  <div className="funded">
                      <div className="title">
                          <div className="text">{lineChart2Heading}</div>
                      </div>
                      <div className="content">
                          <div id={rowChartContainerID}>
                          </div>
                          <div id={rowNAContainerID} className="title" style={{textAlign: 'center'}}>
                          <canvas style={{height: '130px', width:'130px', backgroundColor: '#fff'}} id="CG3.2b" width="50" height="50" />
                              <div className="kf-number" style={{paddingTop: '70px', display: 'none'}}>N/A</div>
                          </div>
                      </div>
                  </div>
              </div> */}
            </div>
          );
    }
  }
}
export default Pillar3;